/**
 * RTK Query endpoint for stopping an active conversation execution.
 */

import { agentsApiSlice } from './agents-api.store'

const CONVERSATIONS_API = '/api/v1/conversations'

const conversationStopEndpoint = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    stopConversationExecution: builder.mutation<void, string>({
      query: (conversationId) => ({
        url: `${CONVERSATIONS_API}/${conversationId}/stop`,
        method: 'POST',
      }),
    }),
  }),
})

export const { useStopConversationExecutionMutation } = conversationStopEndpoint
